import { useEffect, useState, useCallback } from 'react';
import ControlledWhenBlurredTextfield from '../../ControlledWhenBlurredTextfield';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import Operation from './Operation';

export default function Align(props) {
  const {
    machine,
    onUpdate,
    onSave,
    op
  } = props;

  const {
    args
  } = op;

  const [ tempArgs, setTempArgs ] = useState(args);

  useEffect(() => {
    setTempArgs(args);
  }, [ args, setTempArgs ]);

  const handleSave = useCallback((e) => {
    onSave(tempArgs);
  }, [ tempArgs, onSave ]);

  return (<Operation {...props}>
  {
   [ "A", "B", "C" ].map((label) => {
    const index = machine.jointLabels.indexOf(label);
    const setValue = (value) => {
      const newTempArgs = { ...tempArgs, [label]: value };
      onUpdate(newTempArgs);
      setTempArgs(newTempArgs);
    };
    const handleSliderChange = (e, v) => {
      setValue(v);
    };
    const handleTextChange = (e,v) => {
      const newValue = parseFloat(e.target.value);
      if(!isNaN(newValue)) {
        setValue(newValue);
        handleSave()
      }
    }
    if(index !== -1) {
      let min = machine.limits.extents.min[index];
      let max = machine.limits.extents.max[index];
      if(max-min > 360) {
        // TODO, look up whether an axis is continuous or not
        min = -180;
        max = 180;
      }
      return <Stack direction="row" spacing={2} alignItems="center" key={label}><div>{label}</div><Slider onChange={handleSliderChange} onChangeCommitted={handleSave} min={min} max={max} step={1} value={tempArgs[label]}/><ControlledWhenBlurredTextfield value={tempArgs[label]} inputProps={{ inputMode: 'numeric', pattern: '[0-9-.]*', style: { padding: 4, margin: 0 }}} onChange={handleTextChange}/></Stack>
    }
    return null;
  }) } 
  </Operation>);
};
